import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { InternationalizationService } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { ignoreInterceptorHeaders } from '@rx-applications/shared/utils';

@Injectable({ providedIn: 'root' })
export class LanguageInterceptor implements HttpInterceptor {
  readonly #internationalizationService = inject(InternationalizationService);
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(ignoreInterceptorHeaders.ignoreLanguage)) {
      const requestClone = req.clone({
        headers: req.headers.delete(ignoreInterceptorHeaders.ignoreLanguage),
      });
      return next.handle(requestClone);
    }

    return this.#internationalizationService.getLocale().pipe(
      first(),
      switchMap((lang: string) => {
        const reqClone =
          lang.length > 0
            ? req.clone({ setHeaders: { 'Accept-Language': lang } }) // 'en' or 'de' etc, not 'en-US'
            : req;
        return next.handle(reqClone);
      })
    );
  }
}
